import { render, staticRenderFns } from "./PersonalNotification.vue?vue&type=template&id=7c8cd2f0"
import script from "./PersonalNotification.vue?vue&type=script&lang=js"
export * from "./PersonalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports